import { memo } from "react";
import ApproveLeaveAction from "../../../views/user/mytasks/leave/ApproveLeaveAction";

const ApproveLeaveActionView = memo((params) => {
  return <ApproveLeaveAction params={params} />;
});

export { ApproveLeaveActionView };
